import {
	Autocomplete,
	type AutocompleteProps,
	type AutocompleteRenderInputParams,
} from '@mui/material'
import type { ReactNode } from 'react'

interface OrganizationOption {
	id: string
	name?: string
}

const getOrganizationLabel = (option: { name?: string } | string): string =>
	typeof option === 'string' ? option : option.name || ''

type SharedAutocompleteProps<
	Option extends OrganizationOption,
	Multiple extends boolean,
	FreeSolo extends boolean,
> = Pick<
	AutocompleteProps<Option, Multiple, false, FreeSolo>,
	| 'value'
	| 'defaultValue'
	| 'onChange'
	| 'onInputChange'
	| 'filterSelectedOptions'
	| 'isOptionEqualToValue'
	| 'renderOption'
	| 'getOptionLabel'
	| 'multiple'
	| 'freeSolo'
>

interface OrganizationRecipientAutocompleteProps<
	Option extends OrganizationOption,
	Multiple extends boolean,
	FreeSolo extends boolean,
> extends SharedAutocompleteProps<Option, Multiple, FreeSolo> {
	options: readonly Option[]
	renderInput: (params: AutocompleteRenderInputParams) => ReactNode
}

const OrganizationRecipientAutocomplete = <
	Option extends OrganizationOption = OrganizationOption,
	Multiple extends boolean = false,
	FreeSolo extends boolean = false,
>({
	getOptionLabel = getOrganizationLabel,
	...props
}: OrganizationRecipientAutocompleteProps<Option, Multiple, FreeSolo>) => (
	<Autocomplete<Option, Multiple, false, FreeSolo>
		fullWidth
		getOptionLabel={getOptionLabel}
		{...props}
	/>
)

export { getOrganizationLabel, OrganizationRecipientAutocomplete }
